import { render, staticRenderFns } from "./CreateplusMessage.vue?vue&type=template&id=031d2901&scoped=true&"
import script from "./CreateplusMessage.vue?vue&type=script&lang=js&"
export * from "./CreateplusMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d2901",
  null
  
)

export default component.exports